import Title from '@/components/Title/index.vue';
export default {
  name: 'function',
  components: {
    Title
  },
  data() {
    return {
      itemList: [{
        img: require('@/assets/images/securitiessolutions/securitiesSolutions-china.png'),
        title: '内地券商',
        desc: 103
      }, {
        img: require('@/assets/images/securitiessolutions/securitiesSolutions-hongkong.png'),
        title: '香港券商',
        desc: 29
      }, {
        img: require('@/assets/images/securitiessolutions/securitiesSolutions-usa.png'),
        title: '美国券商',
        desc: 2
      }],
      content: '证券经纪商客户概览'
    };
  }
};